import React from 'react';
import { Breadcrumb as SemanticBreadcrumb, Divider } from 'semantic-ui-react'

interface Props {
  screen: string;
}

const Breadcrumb: React.FC<Props> = ({ screen }) => {
  return (
    <>
      <SemanticBreadcrumb size="massive">
        <SemanticBreadcrumb.Section>Portal do Analista</SemanticBreadcrumb.Section>
        <SemanticBreadcrumb.Divider icon='right chevron' />
        <SemanticBreadcrumb.Section link>  {screen}</SemanticBreadcrumb.Section>
      </SemanticBreadcrumb>
      <Divider hidden />
    </>
  );
}

export default Breadcrumb;